
import React from 'react';
import {ChatText} from 'components/Assistant/ChatText';
import {Assistant, Message} from 'components/Assistant/hooks/types';
import {Markdown} from 'components/Markdown';

import {Metadata, MetadataProps} from './Metadata';

export type RenderProps = {
	message: Message
	index: number
	isLast: boolean
	send?: Assistant['send']
	track?: string
}

export type Renderer = (props: RenderProps) => React.ReactNode;

export const defaultRenderer: Renderer = (props) => {
	if (props.message.source === 'METADATA') {
		let parsed = props.message.parsed as MetadataProps;
		if (!parsed) {
			parsed = JSON.parse(props.message.message);
		}
		return (
			<Metadata
				key={`${props.message.id}:${props.index}`}
				{...parsed}
			/>
		);
	}

	return (
		<ChatText
			key={`${props.message.id}:${props.index}`}
			source={props.message.source}
			scroll={props.isLast}
		>
			<Markdown
				markdown={props.message.message}
				track={props.track}
			/>
		</ChatText>
	);
};
